module.exports = __webpack_public_path__ + "img/logo.295bca4e.png";